// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"notFoundContainer__36i2s","notFoundTitle":"notFoundTitle__2vleZ","notFoundSubTitle":"notFoundSubTitle__GoJpW","button":"button__Om1X2"};